import { ScrollTopButton } from "@common/scrollTopButton/ScrollTop";
import { Footer } from "@common/footer/Footer";
import { Header } from "@common/header/Header";
import { CountdownTimer } from "@common/countdown/CountdownTimer";
import { HandleErrorAndLoading } from "@common/handleErrorAndLoading/HandleErrorAndLoading";
import { createContext, useEffect, useState } from "react";
import { Redirect, Switch } from "react-router-dom";
import { Routes } from "@features/Routes";
import { ConnectedModal } from "@features/summary/ConnectedModal";
import { useKeycloak } from "./hooks/useKeycloak";
import "./stylesheets/index.scss";
import { clearStorage, getProspectId } from "@utils/storage";
import { useTwoWayAuthContext } from "./context/TwoWayAuthContext";
import { getLanguage } from "@utils/changeLanguage";
import { ROUTES } from "@constants";

interface INumberOfferContext {
    setNumberOfferSelected(numberOfferSelected: number): void;
}

export const NumberOfferContext = createContext({} as INumberOfferContext);

export const App = () => {
    const [numberOfferSelected, setNumberOfferSelected] = useState(0);
    const { globalLoading, globalError, displayChangedInfoModal, setDisplayChangedInfoModal } = useKeycloak();
    const prospectId = getProspectId();
    const { isTwoWayAuthenticated } = useTwoWayAuthContext();
    const lang = getLanguage();

    useEffect(() => {
        if (!prospectId) {
            setNumberOfferSelected(0);
        }
    }, [prospectId]);

    const getRedirectHomeUrl = (): string => {
        return !lang || lang === "en" ? ROUTES.HOME_PAGE_URL_EN : ROUTES.HOME_PAGE_URL_EL;
    };

    const getRedirectTwoWayAuthUrl = (): string => {
        return !lang || lang === "en" ? ROUTES.TWO_WAY_AUTH_OTP_URL_EN : ROUTES.TWO_WAY_AUTH_OTP_URL_EL;
    };

    return (
        <div id="app-container">
            <HandleErrorAndLoading error={globalError} isLoading={globalLoading}>
                <NumberOfferContext.Provider value={{ setNumberOfferSelected }}>
                    <Header cartItemsNumber={numberOfferSelected} logoutCallback={clearStorage} />
                    <CountdownTimer targetDate="2025-03-31T23:59:59" />

                    <section id="container">
                        <ConnectedModal
                            isModalOpen={displayChangedInfoModal}
                            setModalOpen={setDisplayChangedInfoModal}
                        />
                        <Switch>
                            {Routes}
                            <Redirect to={isTwoWayAuthenticated ? getRedirectHomeUrl() : getRedirectTwoWayAuthUrl()} />
                        </Switch>
                    </section>
                    <ScrollTopButton />
                    <Footer />
                </NumberOfferContext.Provider>
            </HandleErrorAndLoading>
        </div>
    );
};
